import React, { useState, useEffect, useRef } from 'react';
import { postDataFetcher } from '../../dataFetcher';
import CONFIG_OBJECT from '../../config/config';
import LastPeriod from './period-calculator-landing-page/LastPeriod'
import dateUtils from '../../commonUtils/DateUtils';
import App_Constants from '../../app-constants/App_Constants';
import { withTranslation } from 'react-i18next';
import Paginator from './period-calculator-result/Paginator';
import './period-calculator-css/period-calculator.css';
import './period-calculator-css/period-calculator-mobile.css';
import './period-calculator-css/period-calculator-hebrew.css';
import { isMobile } from 'react-device-detect';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import ImageComponent from '../CommonComponent/CommonImage';
import SetReminders from "./set-reminders/SetReminders";
import Symptoms from './period-calculator-result/Symptoms';
import configData from '../../temp/config';
import FutureDates from './future-dates/FutureDates';
import DefaultCalendar from './DefaultCalendar/DefaultCalendar';

var now = new Date();
if (now.getMonth() == 11) {
    var current = new Date(now.getFullYear() + 1, 0, 1);
} else {
    var current = new Date(now.getFullYear(), now.getMonth() + 1, 1);
}

let currentMonthCycle = {
	dayValue: new Date().getDate(),
	monthValue: new Date().getMonth(),
	yearValue: new Date().getFullYear(),
	cycleLength: 0,
	periodDuration: 0,
	selectedDate: '',
	isPeriodChange: false,
	isCycleChange: false
}

let selectedGoal = {
	key: ''
}

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

const PeriodFeatures = (props) => {

	const [goalData, setGoalData] = useState({
		showTrackMyPeriod: false,
		showSetReminder: false,
		showGettingPregnant: false,
		showFutureDates: false,
		goalData: {}
	})
	const [showTitle,setShowTitle] = useState(true);
	const [showResultSection, setShowResultSection] = useState(isMobile ? false : true);
	const [disableBtn, setDisableBtn] = useState(true);
	const [disableAddBtn, setDisableAddBtn] = useState(true);
	const [showForm, setShowForm] = useState(true);
	const [showDesc, setShowDesc] = useState(isMobile ? false : true);
	const [showGoalDesc, setShowGoalDesc] = useState(true);
	const [showChooseOption, setChooseOption] = useState(true);
	const [parentCompData, setParentCompData] = useState({});
	const [componentData, setComponentData] = useState({})
	const [showDisabledInfo, setShowDisabledInfo] = useState(isMobile ? false : false)
	const [showDefaultCalender, setShowDefaultCalender] = useState(isMobile ? false : true)
	const [showAddtoCalender, setShowAddtoCalender] = useState(isMobile ? false : true);
	const [showEditForm, setShowEditForm] = useState(false);
	const [ovulationCalcData, setOvulationCalcData] = useState({
		showCalender: false,
		apiData: {},
		hasError: false,
		showDesc: true,
		showForm: true,
		showDefaultResult: true,
		showWarningSection: false
	});
	const [showGoals, setShowGoals] = useState(true);
	const [showSymptoms, setShowSymptoms] = useState(false);
	const [selectedDay, setSelectedDay] = useState({
		day: '',
		month: '',
		year: '',
		moods: {},
		symptoms: {},
		resultMessage: ''
	});

	// Calling Layout Service and Caching the response 
	useEffect(() => {
		let componentData = props.fields
		setComponentData(componentData);
		if(componentData.wrapperClass.value === 'hebrew') {
		 	require('./period-calculator-css/period-calculator-hebrew.css');
		} 
		// console.log(componentData.wrapperClass.value);
		setParentCompData(props.fields);
	}, [])

	const calculatePeriod = () => {
		// if (enableBtn) {
		let month = Number(currentMonthCycle.monthValue) + 1;
		let data = {
			lastPeriodDate: `${dateUtils.formatDate(month)}-${dateUtils.formatDate(currentMonthCycle.dayValue)}-${currentMonthCycle.yearValue}`,
			periodDuration: Number(currentMonthCycle.periodDuration),
			cycleLength: `${currentMonthCycle.cycleLength}`,
		};

		if (isMobile) {
			setShowDesc(false)
			// setOvulationCalcData({
			// 	showDesc: false
			// });
			setShowForm(false)
		}
		let restURL = '';
		switch (selectedGoal.key) {
			case "PERIOD": {
				restURL = `${CONFIG_OBJECT.PERIOD_CALCULATOR_REST_URL}`
				break;
			}
			case "PREGNANT": {
				restURL = `${CONFIG_OBJECT.GETTING_PREGNANT_REST_URL}`
				break;
			}

		}

		// Calling REST API Url
		postDataFetcher(`${restURL}${App_Constants.SC_API_KEY}&sc_lang=${localStorage.getItem('language')}`, data)
			.then(res => {
				// console.log(res)
				if (res.data.HasError) {
					setOvulationCalcData({
						hasError: true
					})

				} else {
					setShowDefaultCalender(false);
					// setDisableAddBtn(true);
					setOvulationCalcData({
						showCalender: true,
						apiData: res.data.Data,
						showForm: false,
						// shoeDesc: true
						showWarningSection: data.periodDuration > 8
					});
					// setDisableBtn(true);
					if (document.getElementById("calculate-period-button-id")) document.getElementById("calculate-period-button-id").disabled = true;
				}
				if (isMobile) setShowResultSection(true)
				setShowDisabledInfo(false)
				setDisableAddBtn(false);
			}, err => {
				// console.log(err);
				setOvulationCalcData({
					hasError: true
				})
			});
		setShowAddtoCalender(true)
		setShowSymptoms(false)
		if (isMobile) {
			setShowEditForm(true)
		}
		// window.scrollBy(0, 600);

		// }
	}

	// This function gets called whenever we changed anything in child component(Drop-down)
	const sendLastPeriodData = (dayValue, monthValue, yearValue, cycleLength, periodDuration, enableBtn, isPeriodChange, isCycleChange) => {
		currentMonthCycle = {
			dayValue: dayValue,
			monthValue: monthValue,
			yearValue: yearValue,
			cycleLength: cycleLength,
			periodDuration: periodDuration,
			isPeriodChange: isPeriodChange,
			isCycleChange: isCycleChange
		}
		console.log(currentMonthCycle)
		// if (currentMonthCycle.yearValue !== 1970)
		if (enableBtn) {
			setDisableBtn(false)
			document.getElementById("calculate-period-button-id").disabled = false;
		}
		document.getElementById("calculate-period-button-id").focus()
		//setDisableBtn(false);
	}

	const enableButton = () => {
		setDisableBtn(false);
	}

	const { t } = props;

	const showMainMenu = () => {
		setShowForm(true);
		setShowEditForm(false)
		setTimeout(function(){ window.scrollTo(0, 0); }, 0);
		// setDisableBtn(true);
	}

	const mySubmitHandler = (e) => {
		e.preventDefault()
	}

	const setGoal = (item) => {
		currentMonthCycle = {
			dayValue: new Date().getDate(),
			monthValue: new Date().getMonth(),
			yearValue: new Date().getFullYear(),
			cycleLength: 28,
			periodDuration: 4,
			selectedDate: '',
			isPeriodChange: false,
			isCycleChange: false
		}
		if (isMobile) setShowResultSection(false)
		isMobile ? setShowGoals(false) : setShowGoals(true)
		if (isMobile) setChooseOption(true)
		// console.log(item)
		if (item == null) {
			selectedGoal.key = ''
			setGoalData({
				showTrackMyPeriod: false,
				showSetReminder: false,
				showGettingPregnant: false,
				showFutureDates: false,
				goalData: {}
			})
			setShowGoals(true)
			setOvulationCalcData({ showCalender: false })
			isMobile ? setShowDefaultCalender(false) : setShowDefaultCalender(true)
			setShowDisabledInfo(true);
			setShowEditForm(false);
		}
		else if (item.fields.key.value === 'PERIOD' && selectedGoal.key !== item.fields.key.value) {
			selectedGoal.key = item.fields.key.value;
			setGoalData({
				showTrackMyPeriod: true,
				showSetReminder: false,
				showGettingPregnant: false,
				showFutureDates: false,
				goalData: item
			})
			setShowTitle(true)
			setShowForm(true);
			setOvulationCalcData({ showCalender: false })
			isMobile ? setShowDefaultCalender(false) : setShowDefaultCalender(true)
			setShowDisabledInfo(true)
			setChooseOption(false)
			setShowGoalDesc(false)
			setTimeout(function(){ window.scrollTo(0, 0); }, 0);
			// if(!isMobile) executeScroll();

		}
		else if (item.fields.key.value === 'REMINDERS' && selectedGoal.key !== item.fields.key.value) {
			selectedGoal.key = item.fields.key.value;
			setGoalData({
				showTrackMyPeriod: false,
				showSetReminder: true,
				showGettingPregnant: false,
				showFutureDates: false,
				goalData: item
			})
			setShowTitle(true)
			setShowForm(true);
			setOvulationCalcData({ showCalender: false })
			// setShowDefaultCalender(false)
			isMobile ? setShowDefaultCalender(false) : setShowDefaultCalender(true)
			setShowDisabledInfo(true)
			setChooseOption(false)
			setShowGoalDesc(false)
			
		}
		else if (item.fields.key.value === "PREGNANT" && selectedGoal.key !== item.fields.key.value) {
			selectedGoal.key = item.fields.key.value;
			setGoalData({
				showTrackMyPeriod: false,
				showSetReminder: false,
				showGettingPregnant: true,
				showFutureDates: false,
				goalData: item
			})

			setShowTitle(true)
			setShowForm(true);
			setOvulationCalcData({ showCalender: false })
			isMobile ? setShowDefaultCalender(false) : setShowDefaultCalender(true)
			setShowDisabledInfo(true)
			setChooseOption(false)
			setShowGoalDesc(false)
			setTimeout(function(){ window.scrollTo(0, 0); }, 0);

			// setShowDefaultCalender(true)
			// setOvulationCalcData({ showCalender: false })
			// setChooseOption(false)
			// setShowGoalDesc(false)
			// setTimeout(function(){ window.scrollTo(0, 0); }, 0);
			// if(!isMobile) executeScroll();
		}
		else if (item.fields.key.value === 'FUTUREDATES' && selectedGoal.key !== item.fields.key.value) {
			selectedGoal.key = item.fields.key.value;
			setGoalData({
				showTrackMyPeriod: false,
				showSetReminder: false,
				showGettingPregnant: false,
				showFutureDates: true,
				goalData: item
			})
			setShowTitle(isMobile ? false : true)
			setShowForm(true);
			setOvulationCalcData({ showCalender: false })
			// setShowDefaultCalender(false)
			isMobile ? setShowDefaultCalender(false) : setShowDefaultCalender(true)
			setShowDisabledInfo(true)
			setChooseOption(false)
			setShowGoalDesc(false)
		}
		setShowForm(true);
		setShowDesc(false)
		setShowSymptoms(false);
		isMobile ? setShowDefaultCalender(false) : setShowDefaultCalender(true)
		// if((item && item.fields.key.value !== "PREGNANT")) executeScroll();
		// window.scrollTo(0,document.body.scrollHeight);
		// window.scrollBy(0, 600);
	}
	const getSymtopms = (day, dateModel, month, year) => {
		let selectedDate = dateModel.filter((item) => {
			if (item.day == day) {
				return item
			}
		});
		if (selectedDate.length > 0) {
			setSelectedDay({
				day, month, year,
				moods: selectedDate[0].moods,
				symptoms: selectedDate[0].symptoms,
				resultMessage: selectedDate[0].resultMessage
			})
			setShowSymptoms(true)
		}
		// executeSympScroll();
		// window.scrollBy(0, 1000);
		console.log(month, year)
	}

	const checkSymptomps = () => {
		setShowSymptoms(false)
	}

	const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
		"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

	const showEditFormForRemidners = () => {
		if (isMobile) {
			setShowEditForm(true)
		}
	}

	const hideTitle = () => {
		setShowTitle(false)
	}

	const showSubTitle = () => {
		setShowTitle(true)
	}

	const formRef = useRef(null);
	// const sympRef = useRef(null)
	// const executeSympScroll = () => scrollToRef(sympRef)
	const executeScroll = () => {
		// if(document.getElementsByClassName('form-container test').length)
			scrollToRef(formRef)
	}
	let chooseAnotherGoalText = t('PeriodCalculator_ChooseAnotherGoal');
    const chooseAnotherGoalMobText = {
        __html: chooseAnotherGoalText
    }
	return (
		<>
			<div className="container mobile-padding position-relative" >
				{componentData.title &&
					<section id="main" data-test="component-ovulation" className={componentData.wrapperClass.value === 'hebrew' ? "periodCalculatorHebrew" : ''}>
						<div className="period-calculator">
							<div className="calculator-body">
								{/* {showDesc && <h1 className="sub-heading"> {componentData.subHeadingDescription.value}</h1>} */}
								{showDesc && <p className="ovulation-intro">
									{componentData.description.value}
								</p>}
								<div className="goals-section">
									{showChooseOption && <>
										{!isMobile && <hr />}
									<h1>{componentData.chooseFeatureLabel.value}</h1>

									</>
									}
									{/* {
										isMobile && <h1>Choose one of the below goals that you are interested in</h1>
									} */}
									{showGoals ? <div className={!showDesc ? 'remove-goals-padding goals' : "goals"}>
										{!isMobile ? <ul>
											{componentData.features.length > 0 && componentData.features.map((item, index) => {
												return (
													<li className={`${item.fields.key.value === selectedGoal.key ? 'active' : ''}`} key={item.fields.key.value}>
														<span className="circle" onClick={() => setGoal(item)}>
															<ImageComponent imageIcon={item.fields.image.value.src} />
														</span>
														<span className="heading">{item.fields.title.value}</span>
														{showGoalDesc && <span className="desc">{item.fields.summary.value}</span>}
													</li>
												)
											})}
										</ul> : <ul>
												{componentData.features.length > 0 && componentData.features.map((item, index) => {
													return (
														<li className={`${item.fields.key.value === selectedGoal.key ? 'active' : ''}`} key={item.fields.key.value}>
															<span className="circle" onClick={() => setGoal(item)}>
																<ImageComponent imageIcon={item.fields.image.value.src} />
															</span>
															<div onClick={() => setGoal(item)}>
																<span className="heading">{item.fields.title.value}</span>
																<span className="desc">{item.fields.summary.value}</span>
															</div>

														</li>
													)
												})}
											</ul>}
									</div> : <div className="choose-another-goal" onClick={() => setGoal(null)}>
											
											{/* <ImageComponent imageIcon={parentCompData.rightArrowActiveLogo.value.src} /> */}
											{isMobile && <img className="back-arrow" src={`${configData.sitecoreApiHost}${parentCompData.leftArrowActiveLogo.value.src}`} alt="" />}
											<img className="menu-logo" src={`${configData.sitecoreApiHost}${parentCompData.menuLogo.value.src}`} alt="" />
											<span dangerouslySetInnerHTML={chooseAnotherGoalMobText}></span>
										</div>}
									{showEditForm && <div className="recalculate-wrap-period-form">

										<div className="fdlp-mobile">
											<img src={`${configData.sitecoreApiHost}${parentCompData.datePickerLogo.value.src}`} />
											<span>{goalData.goalData.fields.dateSelectionLabel.value}</span><span>{currentMonthCycle.dayValue} {months[currentMonthCycle.monthValue]}, {currentMonthCycle.yearValue}</span>
										</div>
										<div className="avg-period-mobile"><span>{goalData.goalData.fields.durationSelection1Label.value}</span><span>{currentMonthCycle.periodDuration} {props.t('PeriodCalculator_DaysLabel')}</span></div>
										<div className="cycle-length-mobile"><span>{goalData.goalData.fields.durationSelection2Label.value}</span><span>{currentMonthCycle.cycleLength} {props.t('PeriodCalculator_DaysLabel')}</span></div>
										<button onClick={showMainMenu}>
											<img src={`${configData.sitecoreApiHost}${parentCompData.editLogo.value.src}`} />
										</button>
									</div>}
								</div>
								{showTitle && <div className={(selectedGoal.key !== '') ? "goal-header" : ''}>
									<h1 className="sub-heading"> {goalData.goalData.fields && goalData.goalData.fields.title.value} </h1>
									{!isMobile && <p className={(selectedGoal.key === 'FUTUREDATES') ? 'ovulation-intro future-dates-ovulation-intro' : "ovulation-intro"} >{goalData.goalData.fields && goalData.goalData.fields.description.value}</p>}
								</div>}
								{goalData.showSetReminder && <SetReminders componentData={goalData.goalData.fields}
									currentMonthCycle={currentMonthCycle} parentCompData={parentCompData} 
									showEditFormForRemidners={showEditFormForRemidners} 
									hideTitle={hideTitle} showSubTitle={showSubTitle}
									/>}
								
								{goalData.showFutureDates && <FutureDates componentData={goalData.goalData.fields}
									currentMonthCycle={currentMonthCycle} parentCompData={parentCompData} 
									showEditFormForRemidners={showEditFormForRemidners} 
									hideTitle={hideTitle} showSubTitle={showSubTitle}
									/>}

								<div className={(selectedGoal.key !== '') ? "form-container test" : ''} ref={formRef}>
									{showForm && <form role="form" className="form-inline" onSubmit={mySubmitHandler}>
										<div className="toolform">
											{goalData.showTrackMyPeriod && <>
												<LastPeriod sendLastPeriodData={sendLastPeriodData}
													componentData={goalData.goalData.fields}
													parentCompData={parentCompData}
													currentMonthCycle={currentMonthCycle} />
												<div className="submitBtnWrapper">
												<button type="submit" id="calculate-period-button-id" className="btn red calculate-button" onClick={calculatePeriod} disabled={disableBtn}>
													{goalData.goalData.fields.submitLabel.value}
												</button>
												</div>
											</>}

											
											{goalData.showGettingPregnant && <>
												<LastPeriod sendLastPeriodData={sendLastPeriodData}
													componentData={goalData.goalData.fields}
													parentCompData={parentCompData}
													currentMonthCycle={currentMonthCycle} />
													<div className="submitBtnWrapper">
													<button type="submit" id="calculate-period-button-id" className="btn red calculate-button" onClick={calculatePeriod} disabled={disableBtn}>
													{goalData.goalData.fields.submitLabel.value}
													</button>
													</div>
												
											</>}
										</div>

									</form>}
									{(selectedGoal.key !== '' && (selectedGoal.key !== 'REMINDERS'  && selectedGoal.key !== 'FUTUREDATES')) ?
										(showResultSection && <>
											<div className="result-section">
												{ovulationCalcData.showCalender && <div className="higlight-dates">
													<span>{props.t('PeriodCalculator_ClickDatesLabel')}</span>
												</div>}

												<div className="calendar">
													{showDefaultCalender && <div className="default-calendar">
														<DefaultCalendar date={now}/>
														<DefaultCalendar date={current}/>
													</div>
													
														// <ImageComponent imageIcon={componentData.defaultCalendarImage.value.src} />

													}
													{/* Here passing the Period Calculator Result
                							This Paginator Component automatically handles all the Pagination */}
													{ovulationCalcData.showCalender &&
														<Paginator result={ovulationCalcData.apiData} showMainMenu={showMainMenu} sendLastPeriodData={sendLastPeriodData}
															// componentData={componentData}
															componentData={goalData.goalData.fields}
															parentCompData={parentCompData}
															currentMonthCycle={currentMonthCycle}
															getSymtopms={(day, dateModel, month, year) => getSymtopms(day, dateModel, month, year)}
															checkSymptomps={checkSymptomps}
														/>
													}
													{(ovulationCalcData.apiData && ovulationCalcData.apiData.thresholdMessage && ovulationCalcData.showWarningSection) && <div className="period-calculator-warnimg-section">
														<span><strong>{ovulationCalcData.apiData.thresholdMessage}</strong></span>
													</div>}
												</div>
												{showSymptoms && <Symptoms selectedDay={selectedDay} componentData={goalData.goalData.fields} parentCompData={parentCompData}/>}

											</div>
										</>)
										: null}
								</div>

							</div>
						</div>
						
							<div className={componentData.wrapperClass.value === 'hebrew' ? "periodCalculatorHebrew" : ''} >
								<Placeholder name="social-share" rendering={props.rendering} itemid={props.itemid} />

							</div>
					</section>
	

				}
				 
				

				
				{/* {showAddtoCalender && <Placeholder name="add-to-calendar" rendering={props.rendering} disabled={disableAddBtn} itemid={props.itemid}
					currentMonthCycle={currentMonthCycle} />} */}
				
			</div>
			<div className="period-calculator-note-section">
				<p>{componentData.disclaimerMessage && componentData.disclaimerMessage.value}</p>
			</div>

		</>
	)
}

export default withTranslation()(PeriodFeatures);
